import { configNoHeaders } from '@api/constructor-api';

async function restaurantInfoHandler(restaurantUUID) {
  return await configNoHeaders(async (API) => {
    if(restaurantUUID != null && restaurantUUID != 'null')
      return await API.get(`restaurant/${restaurantUUID}`)
    throw 'Not Empty Data'
  });
}

async function checkPhonePackageMember(restaurantUUID,phoneNum) {
  return await configNoHeaders(async (API) => {
    if(restaurantUUID != null && restaurantUUID != 'null')
      return await API.get(`restaurant/${restaurantUUID}/customer/${phoneNum}`)
    throw 'Not Empty Data'
  });
}

export {
  restaurantInfoHandler,
  checkPhonePackageMember
};
